import * as React from 'react';
import * as Moment from 'moment';
import Modal, { ModalSize } from '../misc/components/modal';
import { Subject } from 'webportalclient';
import { TerminationDateModalBody, EarlyTerminationForm } from './TerminationDateModalBody';
import { AuditModal, AuditForm } from "../auditmodal/components/AuditModal";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";
import Alert, { AlertCategoryEnum } from "../misc/components/Alert";

export interface TerminationDateModalProps {
    subjectId: string;
    header: string;
    isVisible: boolean;
    disabled: boolean;
    onCloseModal: () => void;
    notificationBanner?: JSX.Element;
    onSubmit: {
        earlyTerminationButtonEnabled: (newValue: boolean) => void;
        alertMessage?: (alertText: string) => void;
        dirty: React.Dispatch<React.SetStateAction<boolean>>;
    };
}

export const TerminationDateModal = (props: TerminationDateModalProps) => {

    const [terminationFormData, setTerminationFormData] = React.useState<EarlyTerminationForm>();
    const [submitting, setSubmitting] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState<string>(null);
    const Client = useWebPortalApiClient();
    const [auditModalVisible, setAuditModalVisible] = React.useState(false);

    React.useEffect(() => {
        // Clear error alert when modal opens
        setErrorAlert(null);
        const getData = async () => {
            const subject = await Client.client.getSubject(props.subjectId, "id,terminationDate,number");
            const currentDateString = Moment(new Date().toISOString()).format("YYYY-MM-DD HH:mm:ss")

            setTerminationFormData({
                SubjectNumber: subject.number,
                IsTerminated: subject.terminationDate !== undefined && subject.terminationDate !== null,
                TerminationDate: subject.terminationDate ? subject.terminationDate : currentDateString,
            } as EarlyTerminationForm);
        }

        getData();
    }, [props.isVisible, props.subjectId]);

    const onHandleTerminationModalSubmit = async (form: EarlyTerminationForm) => {
        if (JSON.stringify(form) === JSON.stringify(terminationFormData)) {
            props.onCloseModal();
            return;
        }
        if (Moment(form.TerminationDate) > Moment(new Date())) {
            setErrorAlert("Selected Termination date must less than today's date");
            return;
        }
        setTerminationFormData({
            TerminationDate: form.TerminationDate
        } as EarlyTerminationForm);

        setAuditModalVisible(true);
    }

    const onHandleModalSubmit = async (data: EarlyTerminationForm, auditForm: AuditForm) => {
        setSubmitting(true);
        setErrorAlert(null);

        try {
            await Client.client.patchSubjects({
                terminationDate: data.TerminationDate
            }, props.subjectId, auditForm.Annotation);
            setAuditModalVisible(false);
            props.onCloseModal();
            props.onSubmit.earlyTerminationButtonEnabled(true);
            props.onSubmit.alertMessage("Early termination of subject successful")
        } catch (ex) {
            setErrorAlert(ex.message);
        }


        setSubmitting(false);

    }

    if (props.isVisible) {

        return (
            <Modal show={true} header={props.header} size={ModalSize.Normal} closeModalHandler={() => props.onCloseModal()} automationId="TerminationDateModal">
                <Alert show={errorAlert !== null} category={AlertCategoryEnum.Danger}>
                    {errorAlert}
                </Alert>
                {

                    auditModalVisible ?
                        <AuditModal isSubmitting={submitting} onSubmit={(form) => onHandleModalSubmit(terminationFormData, form)} onClose={() => {
                            setAuditModalVisible(false)
                            props.onSubmit.dirty(true)
                            props.onCloseModal();
                        }} header="Update Early Termination Date Reason" />
                        :
                        <TerminationDateModalBody
                            initialValues={terminationFormData}
                            disabled={props.disabled}
                            onSubmit={(form) => { onHandleTerminationModalSubmit(form) }}
                            onCloseModal={props.onCloseModal}
                        />}
            </Modal>
        );
    } else {
        return null;
    }

}
